import $ from "jquery"
import "jquery-match-height";

$('.js-career-perks-match-height').matchHeight();